var extractcustom = function(node){
	return $(node).find('input').val();
};

window.CatalogStats = {
	
	charts : [],
	
	prepareFilterForm: function(){
		var options = {
			success:function(data){
				CatalogStats.processFilterForm(data);
			}, dataType:"json"
		};
		MyForm.prepare("catalogstatsFilterForm", "salestatsCatalog&action=updateListing", options);
		CatalogStats.initListingGraph();
	},
	
	processFilterForm: function(data){
		Listing.refresh("catalogstatsListing", data, data.catalogstats_metadatas);
		CatalogStats.initListingGraph();
	},
	
	initListingGraph: function(){
		
		$('.stats_graph div[e_autograph]').each(function(){
			
			var json = {};
			if($(this).attr('graph_data') !== undefined){
				json = $.parseJSON($(this).attr('graph_data'));
			}
			var seriesData = [];
			
			$.each(json, function(index, value){
				seriesData.push([index, parseInt(value)]);
			});
			
			var chart = $(this).highcharts({
				chart: {
					plotBackgroundColor: null,
					plotBorderWidth: 0,
					plotShadow: false,
                    backgroundColor: "transparent",
				},
				title: {
					text: $(this).attr('graph_title'),
					align: 'center',
					verticalAlign: 'top',
					y: 40
				},
				tooltip: {
					pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
				},
				plotOptions: {
					pie: {
						dataLabels: {
							enabled: false,
							distance: -50,
							style: {
								fontWeight: 'bold',
								color: 'white'
							}
						},
						startAngle: -90,
						endAngle: 90,
						center: ['50%', '75%']
					}
				},
				credits: {
					enabled: false
				},
				series: [{
					type : 'pie',
					name : Loc.g('Représente'),
					innerSize: '50%',
					data : seriesData
				}]
			});
			
			CatalogStats.charts.push(chart);
		});
		
	},
	
};


window.catalogueStat = {
	
	init: function(){
		var options = {success:function(data){catalogueStat.recordFormCallback(data);}, dataType:"json"};
        MyForm.prepare("catalogueStatsForm", "statscatalogue&action=getStats", options, false, false);
		MyFacture.initEvent();
	},
			
	exportCurrent: function(type){
		var formSerialized = $('#catalogueStatsForm').serialize();
		MyFacture.relocate("statscatalogue&action=export&"+formSerialized+"&type="+type, true);
	},		
			
	recordFormCallback: function(data){
		$('#catalogueStatsForm .alert').hide();
		var formIsOk = MyForm.processJson(data, "catalogueStatsForm");
		if(formIsOk) {
			$('#statscatalogue .stats-result').html(data.statscataloguearray);
			$('.tableSort').tablesorter(
				{
					textExtraction: function(node){
						return $(node).find('input').val();
					}
				}
			);
		} else {
			var errorMsg = data.form.msg;
			if(errorMsg.length > 0){
                $('#catalogueStatsForm .alert').html(errorMsg).show();
            }
		}
	},		
	
	switchDocType: function(me){
		var curVal = me.val();
		$('#statscatalogue .stepsToggler').hide();
		$('#statscatalogue .steps_'+curVal).show();
		MyFacture.customForm();
		
	}
	
};

window.ThirdStats = {
	
	prepareFilterForm: function(){
		var options = {success:function(data){ThirdStats.processFilterForm(data);}, dataType:"json"};
		MyForm.prepare("thirdstatsFilterForm", "thirdstats&action=updateListing", options);
	},
	
	processFilterForm: function(data){
		Listing.refresh("thirdstatsListing", data, data.thirdstats_metadatas);
	},
	
};





var colors = ["#7AE7BF","#39CF86","#2980b9","#a280D6","#2E4554","#F5B95B","#F5634A","#F67D8C","#DAE2E6","#99A6AD"];

window.Statistics = {
	
	myGraph : "",
	
	typeDisplay : function(stat, type) {
	
	
		if((stat == "sales" && !$("#mainGraph").hasClass("loadingDatas")) || stat != "sales") {

			$("#filter_typeGraph").val(type);

			if(type === 'line') {

				$("#filter_displayTypeColumn").removeClass("on");
				$("#filter_displayTypeLine").addClass("on");

			}else if(type === 'column') {

				$("#filter_displayTypeLine").removeClass("on");
				$("#filter_displayTypeColumn").addClass("on");
			}

			Statistics.update(stat);
		}

	},
	
	triggerDashboard : function() {
		
		if ($('#statsdashboard .tab-h-menu li.current').length > 0 ){
			$('#statsdashboard .tab-h-menu li.current a').click();
		} else {
			$('#statsdashboard .tab-h-menu li:first a').click();
		}
		
	},
	
	triggerFilterForm : function(){
		
		$('#statFilterForm').submit();
		
	}, 
	
	prepareDashboardFilterForm: function(stat, filters){
		
		// Date
		$("#filter_period_created option:selected").removeAttr("selected");
		$("#filter_period_created option").each(function () {
			
			if(filters.period_created === $(this).val()) {
				
				$(this).attr("selected", "selected");
			}
			
		});
		
		if( $("#filter_period_created").val() === "custom" ) {
			
			$("#filter_period_created_startDate").val(filters.period_created_startDate);
			$("#filter_period_created_endDate").val(filters.period_created_endDate);
		}

	},
	
	init : function(){
		
		$('#graphics_loader').show();
		
		$('#stat_interval').bind('change', function(){
			$('#statFilterForm').submit();
		});
		
		$('#stat_currency').bind('change', function(){
			var newSymbole = $('#stat_currency option:selected').attr('syscode');
			$("span[field='currency']").html(newSymbole);
			$('#statFilterForm').submit();
		});
		
		$('#stat_type').bind('change', function(){
			Persistent.set('graphics_type', $(this).val());
			$('#graphics_display').empty();
			Statistics.graphics();
		});
		
		$('#stat_smartDate').bind('change', function(){
			if($(this).val() === ''){
				$('#customDate').css('display', 'inline');
				MyFacture.customForm('#statFilterForm');
			}
			else{
				$('#customDate').css('display', 'none');
				Statistics.triggerFilterForm();
			}
		});

		$('#stat_startDate').bind('change', function(){
			Statistics.triggerFilterForm();
		});
		
		$('#stat_stopDate').bind('change', function(){
			Statistics.triggerFilterForm();
		});
		
		Statistics.prepareFilterForm('statFilterForm');
	},
	
	delaySales : function(nextloading) {

		if (nextloading == undefined) return;

		$('#statistics').addClass('delayingStats');
		
		MyFacture.post(
			"statistics", 
			{
				action : "loadStatPart",
				stat: "sales",
				loadPart : nextloading
			}, 
			function(data){

				if(data.nextLoad != "") {
					
					Statistics.delaySales(data.nextLoad);
					
				}else {
					
					
					$('#statistics').removeClass('delayingStats');
					$("#mainGraph").removeClass("loadingDatas");
					
					var placeholder = true;
					
					$(".graphHasDatas").each(function(i, elem){
						if($(elem).val() == "Y" && placeholder) {
							placeholder = false;
						}
					});

					if(placeholder) {
						$("#graphics_noData").show();
						Statistics.calcLeftGraphic();
					}
					
				}
				
				// Numbers
				$("#statDashHeaderNum tr td#blankRight").before(data.numberHtml);
				
				if(data.nextLoad == "") {
					$("#statDashHeaderNum tr td#blankRight").remove();
				}
				
				$(".explain_tip").qtip({
					style : {
						classes : 'custom-qtip',
						def		: false
					},
					position: {
						viewport: true
					}
				});
				
				
				// Legend
				if(typeof(data.legend) != "undefined") {
					
					$("#legend .inlineList").append(data.legend);
					
					// Graph
					var theChart = $("#mainGraph").highcharts();

					var serie = {
						yAxis: data.graph.y,
						type: $("#filter_typeGraph").val(),
						legendIndex: data.graph.id,
						name: data.graph.label,
						data: data.graph.data,
						color: data.graph.color
					};
										
					if (theChart !== undefined){
						theChart.addSeries(serie, true, true);
					}
					
				}

			}, 
			"json",
			true
		);
	},
	
	initDashboard: function(stat) {
		
		if ($('#statistics').hasClass('delayingStats')){
			return false;
		}
		
		if(typeof(Highcharts.charts[0]) != "undefined") {
			
			Highcharts.charts[0].destroy();
		}
		
		if(stat == "sales") {
			$("#mainGraph").addClass("loadingDatas");
		}

		// Loading stats
		$("#graphics_noData").hide();
		$("#statWrapper").html('');
		$('#graphics_loader').show();
		$('#graphics_loader').fadeTo("slow",1);
		
		$('#statsdashboard .tab-h-menu li.current').removeClass("current");
		$('#statsdashboard .tab-h-menu li a#pan-'+stat).parent().addClass("current");

		$("#graphics_noEntries .title, #graphics_noEntries .intro, #graphics_noEntries .buttons").empty();
		$("#graphics_noEntries").hide();

		// remove all remaining requests
		MyFacture.cleanQueue();
		
		MyFacture.post(
			"statistics", 
			{action : "loadStats", stat: stat}, 
			function(data){
				const updateStatsReport = new CustomEvent('updateStatsReport', { detail: {reportCode: stat} });
				window.dispatchEvent(updateStatsReport);
				// CheckAlive test
				if (data.status == 'logout') {
					CheckAlive.performCallback(data);
					return;
				}

				if(stat == "sales") {
					Statistics.delaySales(data.nextLoad);
				}

				$("#statWrapper").html(data.html);
				$('#graphics_loader').delay(200).fadeTo('slow','0');
				$('#graphics_loader').hide();
				$('body').data('stats', data.statsData);
					
				// second graph holder
				if(typeof(data.statsData.secondGraph) !== "undefined") {

					$("#secondGraph").addClass("col span_3");
					$("#mainGraph").addClass("col span_9");

				}else {
					$("#secondGraph").removeClass("col span_3");
					$("#mainGraph").removeClass("col span_9");
				}
				
				Statistics.prepareDashboardFilterForm(stat, data.filters);
			
				MyFacture.customForm();
				Qtip.init();
				
				if(typeof(data.statsData.placeholder) !== "undefined" && data.statsData.placeholder === 1) {
					$("#graphics_noData").show();
					Statistics.calcLeftGraphic();

				}else {
					
					if(typeof(data.statsEntries.hasEntries) !== "undefined" && data.statsEntries.hasEntries === 'N') {

						$("#graphics_noData").hide();

						$("#graphics_noEntries .title").html(data.statsEntries.noEntries.title);
						$("#graphics_noEntries .intro").html(data.statsEntries.noEntries.intro);
						$("#graphics_noEntries .buttons").html(data.statsEntries.noEntries.buttons);

						$("#graphics_noEntries").fadeIn('slow');
						$('#graphics_noData').remove();
						
					}else {
						
						eval( "Statistics.graphDashboard('"+ stat +"')" );
					}
				}
			
				// Tolltips d'info de calcul sur les numbers
				$(".explain_tip").qtip({
					style : {
						classes : 'custom-qtip',
						def		: false
					},
					position: {
						viewport: true
					}
				});

				$(".explain_tip").removeClass("explain_tip");

				var options = {
					success : function(data) {


						$('#graphics_loader').delay(200).fadeTo('slow','0');
						$('#graphics_loader').hide();

						$("#mainGraph, #secondGraph").html("");

						if(typeof(data.statsData.placeholder) !== "undefined" && data.statsData.placeholder === 1) {
							$("#graphics_noData").show();
							Statistics.calcLeftGraphic();
							
						}else {

								if(typeof(data.statsData.secondGraph) !== "undefined") {

									$("#secondGraph").addClass("col span_3");
									$("#mainGraph").addClass("col span_9");

								}else {
									$("#secondGraph").removeClass("col span_3");
									$("#mainGraph").removeClass("col span_9");
								}

								$('body').data('stats', data.statsData);

								
								
								if(stat == "sales" && typeof(data.nextLoad) != "undefined") {

									var datas = data.statsData;	
									var marker = datas.xAxis.length === 1 ? true : false;
									var numFormat = NumberFormat.load();
									var currency = $("#filter_currency").length > 0 ? $("#filter_currency option:selected").attr("syscode") : numFormat.currency;
									var yAxis = new Array();
									
									$.map(datas.yAxis, function(value, index) {

										yAxis.push({
											id: value.id,
											min: value.min,
											title: {
												text: value.label
											},
											labels: {
												align: value.align,
												x: 0,
												y: -2
											},
											startOnTick: false,
											minPadding: 0.3,
											opposite: value.align === "right" ? true : false
										});
									});
			
									// Main graph options
									
									var options = {
										series : [],
										chart: {
											renderTo: 'mainGraph',
											zoomType: 'x',
											margin: [35,35,40,35],
                                            backgroundColor: "transparent",
										},
										title: {
											text: ""
										},
										legend: {
											enabled: false
										},
										lang: {
											noData: Loc.g('Aucune donnée à afficher')
										},
										credits: {
											enabled: false
										},
										tooltip: {
											formatter: function() {
												var tip = "";
												var pointY = NumberFormat.formatToDisplay(this.y, numFormat);
												tip = '<b>'+pointY+'</b> '+currency;
												return '<b>'+this.x+'</b><br/><span style="color:'+this.series.color+'">'+this.series.name+'</span>: <b>'+tip+'</span>';
											}
										},
										xAxis: {
											categories: datas.xAxis,
											type: 'datetime',
											tickInterval: datas.xAxisInterval,
											labels: {
												align: 'left',
												x: 3,
												y: 20
											}
										},
										yAxis: yAxis,
										plotOptions: {
											series: {
												marker: {
													enabled: marker
												}
											},
											column : {
												stacking: false
											}
										}
									};
									
									this.myGraph = new Highcharts.Chart(options);
									
									for (var key in data.statsData.line){
										var current = data.statsData.line[key];
										
										var serie = {
											type: $("#filter_typeGraph").val(),
											legendIndex: current.id,
											name: current.label,
											data: current.data,
											color: current.color
										};
										this.myGraph.addSeries(serie, true, true);
									}
									
									$("#statDashHeaderNum tr td#blankRight").before(data.numberHtml);
									$("#legend .inlineList").append(data.legend);
									
									Statistics.delaySales("late");

								} else {
									eval( "Statistics.graphDashboard('"+ stat +"')" );
								}
								
							}
						Statistics.loadNumbers(stat, data.numbers);

						MyFacture.customForm();
						Qtip.init();
						
					},
					dataType : "json",
					data : {
						action:"updateStats", 
						stat: stat
					}
				};

				MyForm.prepare('statsFilterForm_'+stat, "statistics", options, false);
				
			}, 
			"json"
		);
	},
	
	update: function(stat) {

		if(stat == "sales") {

			$("#mainGraph").addClass("loadingDatas");
			$("#statDashHeaderNum tbody tr").html("");
			$("#statDashHeaderNum tr").append("<td id='blankRight' style='color: #fff;'>.</td>");
			$("#legend .inlineList").html("");

		}

		if( $("#filter_period_created").val() === "custom") {

			$("#period_created_custom").removeClass("hidden");
		}else {

			$("#period_created_custom").addClass("hidden");
		}

		$("#graphics_noData").hide();
		$('#graphics_loader').show();
		$('#graphics_loader').fadeTo("slow",1);

		// legend reset
		$("#legend li.disabled").removeClass("disabled");

		// remove all remaining requests
		MyFacture.cleanQueue();
		
		// submit the form
		$("#statsFilterForm_"+stat).submit();

	},
	
	loadNumbers : function(stat, numbers) {

		for (key in numbers) {
			
			var id = numbers[key].id;

			// value
			$("td#numbers_" + id + " span.amount").html(numbers[key].value);
			
			// label
			if(typeof(numbers[key].nbdocs) !== "undefined") {
				
				$("td#numbers_" + id + " span.numbersLabel").html(numbers[key].nbdocs);
			}
			
			// label
			if(typeof(numbers[key].modalsearch) !== "undefined") {
				
				$("td#numbers_" + id + " a.numbersUrl").attr("href",numbers[key].modalsearch);
			}
			
		}
	},
	
	
	// New refactoring statsDashboard
	graphDashboard : function(stat) {
		
		var datas = $('body').data('stats');
		var type = $("#filter_typeGraph").val();
		var marker = datas.xAxis.length === 1 ? true : false;
		var numFormat = NumberFormat.load();
		var currency = $("#filter_currency").length > 0 ? $("#filter_currency option:selected").attr("syscode") : numFormat.currency;

		var yAxis = new Array();
		var series = new Array();
		
		$.map(datas.yAxis, function(value, index) {

			yAxis.push({
				id: value.id,
				min: value.min,
				title: {
					text: value.label
				},
				labels: {
					align: value.align,
					x: 0,
					y: -2
				},
				startOnTick: false,
				minPadding: 0.3,
				opposite: value.align === "right" ? true : false
			});
		});
		


		
		$.map(datas.line, function(value, index) {

			series.push({
				yAxis: value.y,
				type: type,
				legendIndex: value.id,
				name: value.label,
				data: value.data,
				color: value.color
			});
		});

		if(stat === "timetracking") {
			
			i = 1;
			
			$.map(datas.bar, function(value, index) {

				series.push({
					type: "column",
					name: index,
					data: value,
					zIndex: 1,
					color: colors[i],
					stack: 1
				});

				if($("#itemLegend_"+i).length === 0) {
					// third legend
					var myLegend = '<li class="itemLegend" id="itemLegend_'+i+'" onClick="Statistics.toggleLegend('+i+');" style="border-left-color: '+colors[i]+';">'+index+'</li>';
					$("#legend .inlineList").append(myLegend);
				}

				i++;
			});
		}

		// Main graph options
		var hasSeconds = $('#statDashHeaderNum').data('useprecisionsecond');
		var options = {
            chart: {
				renderTo: 'mainGraph',
				zoomType: 'x',
				margin: [35,35,40,35],
                backgroundColor: "transparent",
            },
            title: {
                text: ""
            },
			legend: {
				enabled: false
			},
			lang: {
				noData: Loc.g('Aucune donnée à afficher')
			},
			credits: {
				enabled: false
			},
			tooltip: {
				formatter: function() {
					
					if(stat === 'support' && this.series._i === 2) {
						var tip = datas.line.replyTime.data_label[this.point.x];
						return '<b>'+this.x+'</b><br/><span style="color:'+this.series.color+'">'+this.series.name+'</span>: <b>'+tip+'</span>';
					} else {
						var tip = "";

						if(datas.yAxis[this.series.yAxis.options.index].isNumFormat) {
							var pointY = NumberFormat.formatToDisplay(this.y, numFormat);
							tip = '<b>'+pointY+'</b> '+currency;
						}else {
							tip = '<b>'+this.y+'</b>';
						}
						
						if(stat == 'timetracking') {
							var data = {
								raw		: this.y,
								hours	: Math.floor(this.y / 60),
								minutes	: Math.floor(this.y % 60)
							};
							if (hasSeconds == true) {
								data = {
									hours	: Math.floor(this.y / (60*60)),
									minutes	: Math.floor((this.y/60) % 60),
									seconds	: this.y % 60
								};
							}

							tip = '<b>';
							if (data.hours > 0) {
								tip += data.hours + ' h ';
							}
							if (data.hours > 0) {
								tip += data.minutes + ' min';
							}
							if (hasSeconds == true) {
								tip += ' '+data.seconds + ' s.';
							}
							tip += '</b>';
							
						}

						return '<b>'+this.x+'</b><br/><span style="color:'+this.series.color+'">'+this.series.name+'</span>: <b>'+tip+'</span>';
					}
				}
			},
            xAxis: {
				categories: datas.xAxis,
				type: 'datetime',
				tickInterval: datas.xAxisInterval,
                labels: {
                    align: 'left',
                    x: 3,
                    y: 20
                }
            },
			yAxis: yAxis,
			plotOptions: {
				series: {
					marker: {
						enabled: marker
					}
				},
				column : {
					stacking: false
				}
			},
            series: series
        };

		if(stat === "timetracking") {
			if (!hasSeconds) {
				for (key in series) {
					series[key].data = $.map(series[key].data, function(v) {
						return Math.floor(v/60);
					});
				}
			}
			options.plotOptions.column.stacking = "normal";
		}
		
		this.myGraph = new Highcharts.Chart(options);

		// Second graph
		if(typeof(datas.secondGraph) !== "undefined") {
			
			pieData = new Array();
			
			i = 0;
			i_c = 0;
			
			$.map(datas.secondGraph.data, function(value, index) {
				pieData.push({
					name: index,
					y: value,
					color: colors[i_c]
				});
				
				i++;
				i_c++;
				
				if( i_c >= colors.length) {
					i_c = 0;
				}
			});
			
			if(stat !== "prospection") {

				var optionsSecond = {
					chart: {
						renderTo: 'secondGraph',
						margin: [35,35,40,35],
                        backgroundColor: "transparent",
					},
					title: {
						style: {
							"fontSize": "16px"
						},
						text: datas.secondGraph.label
					},
					credits: {
						enabled: false
					},
					tooltip: {
						formatter: function() {
							if (stat === 'support') {
								this.y = Math.floor(this.y/60);
								return this.key+ '<br><b>'+this.percentage.toFixed(2)+'%</b>';
							} else if(stat === 'timetracking'){
								var unit = 'min';
								this.y = Math.floor(this.y/60);
							}
							else{
								var unit = currency;
							}
							return this.key+ '<br><b>'+this.percentage.toFixed(2)+'% - '+this.y+' '+unit+'</b>';
						}
					},
					plotOptions: {
						pie: {
							allowPointSelect: true,
							cursor: 'pointer',
							dataLabels: {
								enabled: false
							}
						}
					},
					series: [{
						type: 'pie',
						data: pieData
					}]
				};

				new Highcharts.Chart(optionsSecond);
				
			}else {
				

				var myFunnel = $.map(datas.secondGraph.data, function(value, index) {
					return [[index, parseInt(value, 10)]];
				});

				// Funnel chart
				var optionsFunnel = {
					chart: {
						renderTo: 'secondGraph',
						type: 'funnel',
						margin: [35,150,40,35],
                        backgroundColor: "transparent",
					},
					title: {
						text: ""
					},
					credits: {
						enabled: false
					},
					tooltip: {
						positioner: function (a,b,c) {
							return { x: 80, y: c.plotY};
						}
					},
					plotOptions: {
						series: {
							dataLabels: {
								enabled: true,
								format: '<b>{point.name}</b> ({point.y:,.0f})',
								color: 'gray-100' ,
								softConnector: true
							}
						}
					},
					legend: {
						enabled: false
					},
					lang: {
						noData: Loc.g('Aucune donnée à afficher')
					},
					series: [{
						name: Loc.g('Nombre d‘opportunités'),
						data: myFunnel
					}]
				};

				new Highcharts.Chart(optionsFunnel);
				
			}
			
		}else {
			
			$("#secondGraph").html("");
		}
		
	},

	toggleLegend: function(serie) {
		
		
		this.myGraph = $("#mainGraph").highcharts();
		
		var legendItm = $("#legend #itemLegend_"+serie);

		if(this.myGraph.series[serie] !== undefined && this.myGraph.series[serie].visible) {

			this.myGraph.series[serie].hide();
			legendItm.addClass("disabled");
			
		}else {

			if(this.myGraph.series[serie] !== undefined){
				this.myGraph.series[serie].show();
			}

			legendItm.removeClass("disabled");
		}		
	},
	
	prepareFilterForm: function(formId){
		var options = {
			success: function(data){
				Statistics.updateStatsCallback(data);
			},
			dataType:"json"
		};
		var params = {'action': 'updateOldStats'};

		MyForm.prepare(formId, "statistics&"+$.param(params), options);
//		MyFacture.initEvent(formId);
		MyFacture.customForm('#'+formId);
		
	},	
	
	updateStatsCallback : function(data){
		var numformat	= NumberFormat.load();
		var formIsOk	= MyForm.processJson(data, 'statFilterForm');

		if(formIsOk){
			
			if (Utils.exists("graphics")){
				var charts = data.statsData.chartStats.stats;
				var axis = data.statsData.chartStats.infos.chartAxis;
				// Graphic Axis
				var htmlAxis = '';
				for(i = 0; i < axis.length; i++){
					htmlAxis += '<span>'+axis[i]+'</span>';
				}
				// Graphic Datas
				var htmlChart = '';
				var htmlColors = '';

				for(var i  in charts){
					var myChart = charts[i];
					htmlChart += '<div>';
					htmlChart += '<span field="name">'+myChart['name']+'</span>';
					htmlChart += '<span field="color">'+myChart['color']+'</span>';
					htmlChart += '<span field="hasCurrency">'+(myChart['hasCurrency'] !== undefined ? myChart['hasCurrency'] : '')+'</span>';
					htmlChart += '<div field="data">';
					for(var j in myChart['data']){
						htmlChart += '<span>'+parseFloat(myChart['data'][j], 10)+'</span>';
					}
					htmlChart += '</div>';
					htmlChart += '</div>';
					
					htmlColors += '<span>'+myChart['color']+'</span>';
				}
				var myPersistent = '<div field="head">'+htmlAxis+'</div>'
								 + '<div field="datas">'+htmlChart+'</div>'
								 + '<div field="colors">'+htmlColors+'</div>';
				Persistent.set('graphics_data', myPersistent, '', false);
				$('#graphics_display').empty();
				
				switch(data.statsData.filters.context){
					case 'third':
						Third.statGraph();
						break;
					case 'item':
						catalogueItem.statGraph();
						break;
					case 'pos':
						$('#stat_type').val(data.statsData.filters.type);
						Persistent.set('graphics_type', data.statsData.filters.type);
						Statistics.graphics();
						break;
					default :
						Statistics.graphics();
						break;
				}
			}
			
			if(Utils.exists('totalContent')){
				var totals = data.statsData.stats;
				// Totals
				for(var lblTotal in totals){
					var recap = totals[lblTotal];
					$('#block_'+lblTotal).find('.amount').html(recap.total);
					$('#block_'+lblTotal).find('.nbDocs').html(recap.lbl);
					$('#block_'+lblTotal).find('.unit').html(recap.unit);
					$('#block_'+lblTotal).find('.nbDocument_total a').attr('href', recap.url);
					// update kpis in KpiList.vue
					$(`.kpi-item--${lblTotal}`).find('.kpi-item__value').html(recap.total);
				}
			}
			
			$('.filterStartDate').html(data.statsData.filters.formatted_startDate);
			$('.filterStopDate').html(data.statsData.filters.formatted_stopDate);
			
			if(Utils.exists('topThreeThird')){
				$('#topThreeThird ol').empty();
				if(data.statsData.topten.thirds.length > 0){
					$('#topThreeThird .placeholder').hide();
					for(i = 0; i < data.statsData.topten.thirds.length;i++){
						var itm = data.statsData.topten.thirds[i];
						$('#topThreeThird ol').append('<li>'
												+'<span class="name">'+itm.linkedName+'</span>'
												+'<span class="price"> ('+itm.nb+')</span>'
												+'<div class="clear"></div>'
												+'</li>');
					}
				} else{
					$('#topThreeThird .placeholder').show();
				}
				
			}
			
			if(Utils.exists('topThreeStaff')){
				$('#topThreeStaff ol').empty();
				if(data.statsData.topten.owners.length > 0){
					$('#topThreeStaff .placeholder').hide();
					for(i = 0; i < data.statsData.topten.owners.length;i++){
						var itm = data.statsData.topten.owners[i];
						$('#topThreeStaff ol').append('<li>'
												+'<span class="name">'+itm.linkedName+'</span>'
												+'<span class="price"> ('+itm.nb+')</span>'
												+'<div class="clear"></div>'
												+'</li>');
					}						
				} else{
					$('#topThreeStaff .placeholder').show();
				}
			}
			
			if(Utils.exists('topTenItm')) {
				$('#topTenItm ol').empty();
				if(data.statsData.topten.length > 0) {
					$('#topTenItm .placeholder').hide();
					for(i = 0; i < data.statsData.topten.length;i++) {
						var itm = data.statsData.topten[i];
						$('#topTenItm ol').append('<li class="'+(i % 2 == 0 ? 'pair' : 'impair')+'">'
												+'<span class="name">' + itm.name + '</span>'
												+'<span class="price">' + itm.unitAmount + '</span>'
												+'<div class="clear"></div>'
												+'</li>');
					}
				} else {
					$('#topTenItm .placeholder').show();
				}
			}
		}
		
		$('#graphics_loader').fadeOut();
	},
	
	graphics: function(){
		
		var object = Persistent.get("graphics_data",true,true);
		var displayGraphics = Persistent.get("graphics_data_display",false);
		var typeGraphic = Persistent.get("graphics_type",false);
		
		if(typeGraphic == 'undefined' || typeGraphic == ''){
			typeGraphic = 'line';
		}
		
		if(displayGraphics=='N') Statistics.hideGraphics();
		
		for(var i in object.datas){
			for(var j in object.datas[i].data){
				object.datas[i].data[j] = parseFloat(object.datas[i].data[j], 10);
			}
		}

		var options= {
			colors:object.colors, 
			data : object.datas, 
			type:typeGraphic, 
			container : 'graphics_display', 
			xAxis:object.head, 
			xAxisStep : object.head.length >= 16 ? Math.ceil(object.head.length/16) : 1,
			height:220,
			background:'#FFF',
			legendHAlign : "right",
			legendVAlign : 'bottom',
			legendWidth : 150,
			legendBg : "#F5F5F5",
			legendBorder : "#E5E5E5",
			legendX : 10
			
		};
    },

    hideGraphics: function(){
		
		$('#graphics_display').delay(500).fadeTo('slow','0.3');
		$('#graphics_options').delay(500).fadeTo('slow','0.3');
		$('#graphics_anim').delay(500).fadeIn();
		$('#statFilterForm :input').each(function(){
			$(this).attr('disabled' , 'disabled');
		});
	},
	
	calcLeftGraphic: function() {
		var width = $(document).width();
		
		var rightPanel = $('#pane-slider-right').width();
		var margin = parseInt($('.contentMargin').css('margin-left'), 10) + parseInt($('.contentMargin').css('margin-right'), 10);

		var base = width - (rightPanel + margin);
		var left = (base / 4) + (rightPanel + margin);
		
	},
	
	openInformations: function(stats) {
		var options = {
			title	: Loc.g("Plus d'informations"),
			width	: 500,
			buttons : [
				{
					text	: Loc.g("Fermer"),
					click	: function() {
						$(this).dialog('close');
					}
				}
			],
			callback: function() {}
		};
		
		var params = {
			action	: 'openInformations',
			stats	: stats
		};
		MyWindow.load('statistics', params, options);
	}
};
